<div class="search-wrapper">
  <div class="search-container">
    <app-icon icon="search" class="icon_search"></app-icon>
    <input class="search-input" [placeholder]="placeholder" maxlength="50" [id]="inputId" [(ngModel)]="filter"
      (ngModelChange)="onKeyup($event)"  tabindex="0">
    <app-icon icon="clear" [id]="inputId + '-clear'" *ngIf="filter" (click)="clear()" class="pointer" tabindex="0" (keyup)="clear()"></app-icon>
  </div>
</div>
